import { useState, useEffect } from 'react'
import MainTitle from './MainTitle'
import { useParams } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import { ImageConfig } from './ImageConfig'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'

const Resources = () => {
  const axios = useAxiosPrivate()
  const [showFiles, setShowFiles] = useState([])
  const { setShowLoader, createInfo } = useAuth()
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    getResources()
  }, [])

  const getResources = async () => {
    setShowLoader(true)
    try {
      const response = await axios.get(`/clients/shared-documents`)
      const result = response.data.result

      setShowFiles(
      Array.isArray(result)
        ? result
        : result && typeof result === 'object'
        ? Object.values(result)
        : []
    )
    } catch (error) {
      setShowFiles([])
    }
    setShowLoader(false)
  }

  useEffect(() => {
    init()
  }, [])

  const init = async () => {
    setShowLoader(true)
    await Promise.all([getResources(), getDocumentGroups()]);
  }

  const getDocumentGroups = async () => {
  try {
    const response = await axios.get('/shared-documents/groups');
    const result = response.data.result;

    setGroups(
      Array.isArray(result)
        ? result
        : result && typeof result === 'object'
        ? Object.values(result)
        : []
    );
  } catch (e) {
    setGroups([]);
  }
};

const safeShowFiles = Array.isArray(showFiles) ? showFiles : [];

const safeGroups = Array.isArray(groups) ? groups : [];

const getGroupName = (groupId) => {
  for (let i = 0; i < safeGroups.length; i++) {
    if (safeGroups[i] && safeGroups[i].id === groupId) {
      return safeGroups[i].name;
    }
  }
  return 'Group';
};

  return (
    <section>
      <MainTitle title="Resources" backButton />
      <section className="w-full bg-white rounded-xl shadow-md py-4 px-4 mb-8">
        <h2 className="font-bold text-lg mb-4">{getGroupName(1)}</h2>

        <div className="grid grid-cols-4 gap-3">
          {safeShowFiles.filter(file => file.shared_document_group_id === 1).map((item, index) => (
              <div
                key={index}
                className="grid lg:grid-cols-3 gap-2"
              >
                <div className="flex flex-wrap items-center col-span-2">
                  <img
                    src={
                      ImageConfig[item.name.split('.')[1]] ||
                      ImageConfig['default']
                    }
                    alt=""
                    className="w-14 xl:w-16"
                  />

                  <div className="drop-file-preview__item__info text-sm xl:text-base break-all">
                    <p>{item.name}</p>
                  </div>
                </div>

                

                  <a href={item.url} target="_blank" rel="noreferrer">
                    <FontAwesomeIcon
                      icon={faDownload}
                      className="w-3 h-3 xl:w-4 xl:h-4 border border-green-200 text-emerald-700 cursor-pointer rounded-full bg-green-200 p-1.5 xl:p-2 hover:border-emerald-500 hover:bg-emerald-500 hover:text-white"/>
                  </a>
                </div>
          ))}
        </div>

      </section>

      <section className="w-full bg-white rounded-xl shadow-md py-4 px-4 mb-8">
        <h2 className="font-bold text-lg mb-4">{getGroupName(2)}</h2>

        <div className="grid grid-cols-4 gap-3">
          {safeShowFiles
            .filter((file) => file.shared_document_group_id === 2)
            .map((item, index) => (
              <div key={index} className="grid lg:grid-cols-3 gap-2">
                <div className="flex flex-wrap items-center col-span-2">
                  <img
                    src={ImageConfig[item.name.split('.')[1]] || ImageConfig['default']}
                    alt=""
                    className="w-14 xl:w-16"
                  />
                  <div className="drop-file-preview__item__info text-sm xl:text-base break-all">
                    <p>{item.name}</p>
                  </div>
                </div>

                <a href={item.url} target="_blank" rel="noreferrer" >
                    <FontAwesomeIcon
                      icon={faDownload}
                      className="w-3 h-3 xl:w-4 xl:h-4 border border-green-200 text-emerald-700 cursor-pointer rounded-full bg-green-200 p-1.5 xl:p-2 hover:bg-transparent hover:border-emerald-700"/>
                  </a>
                </div>
            ))}
        </div>
    </section>

     <section className="w-full bg-white rounded-xl shadow-md py-4 px-4 mb-8">
        <h2 className="font-bold text-lg mb-4">{getGroupName(3)}</h2>

        <div className="grid grid-cols-4 gap-3">
          {safeShowFiles
            .filter((file) => file.shared_document_group_id === 3)
            .map((item, index) => (
              <div key={index} className="grid lg:grid-cols-3 gap-2">
                <div className="flex flex-wrap items-center col-span-2">
                  <img
                    src={ImageConfig[item.name.split('.')[1]] || ImageConfig['default']}
                    alt=""
                    className="w-14 xl:w-16"
                  />
                  <div className="drop-file-preview__item__info text-sm xl:text-base break-all">
                    <p>{item.name}</p>
                  </div>
                </div>

                <a href={item.url} target="_blank" rel="noreferrer" >
                    <FontAwesomeIcon
                      icon={faDownload}
                      className="w-3 h-3 xl:w-4 xl:h-4 border border-green-200 text-emerald-700 cursor-pointer rounded-full bg-green-200 p-1.5 xl:p-2 hover:bg-transparent hover:border-emerald-700"/>
                  </a>
                </div>
            ))}
        </div>
 </section>
 </section>
  )
}
export default Resources
